/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Box, Button, Typography, Select, InputLabel, FormControl, MenuItem } from '@mui/material';

const style = {
  position: 'absolute',
  top: '10%',
  left: '50%',
  width: '50%',
  transform: 'translate( -50%, 0%)',
  bgcolor: '#000000d0',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 4
};

const DeviceList = ({
  visibility,
  deviceCategoryLabel,
  selectedDeviceId,
  deviceList,
  onSelectDevice,
}) => {
  if (!visibility) {
    return null;
  }

  const handleSelect = (e) => {
    onSelectDevice(e.target.value);
  }

  return (
    <Box sx={{my: 2}}>
      <FormControl
        aria-label={deviceCategoryLabel}
        sx={{width: '100%'}}
        variant="outlined"
      >
        <InputLabel >{deviceCategoryLabel}</InputLabel>
        <Select
          label={deviceCategoryLabel}
          value={selectedDeviceId}
          onChange={handleSelect}
        >
          {deviceList.map((device, idx) => 
            <MenuItem aria-label={device.label} key={idx} value={device.deviceId}>
              <Typography color={'lightgrey'}>{device.label}</Typography>
            </MenuItem>
        )}
        </Select>
      </FormControl>
    </Box>
  );
};

const SelectMediaDeviceComponent = ({
  activeAudioInputId,
  activeVideoInputId,
  activeAudioOutputId,
  audioInputDevices,
  videoInputDevices,
  audioOutputDevices,
  onConfirm,
  onCancel,
}) => {

  const [selectedAudioInputId, setAudioInputId] = useState(activeAudioInputId);
  const [selectedVideoInputId, setVideoInputId] = useState(activeVideoInputId);
  const [selectedAudioOutputId, setAudioOutputId] = useState(activeAudioOutputId);

  const onClickConfirm = () => {
    if (selectedAudioInputId !== activeAudioInputId || selectedVideoInputId !== activeVideoInputId || selectedVideoInputId !== activeAudioOutputId) {
      onConfirm({
        newAudioInputId: selectedAudioInputId,
        newVideoInputId: selectedVideoInputId,
        newAudioOutputId: selectedAudioOutputId,
      });
    }
  }

  const audioInput = audioInputDevices;
  const videoInput = videoInputDevices;
  const audioOutput = audioOutputDevices;

  const selectAudioInput = (id) => {
    setAudioInputId(id);
  };

  const selectVideoInput = (id) => {
    setVideoInputId(id);
  };

  const selectAudioOutput = (id) => {
    setAudioOutputId(id);
  };

  return (
    <Box sx={style}>
      <Typography variant="h4" color={'lightgrey'} sx={{mb: 4}}>Setup Video and Audio</Typography>
      <DeviceList
        visibility={audioInput.length > 0}
        deviceCategoryLabel={'Microphone'}
        deviceList={audioInput}
        selectedDeviceId={selectedAudioInputId}
        onSelectDevice={selectAudioInput}
      />
      <DeviceList
        visibility={videoInput.length > 0}
        deviceCategoryLabel={'Camera'}
        deviceList={videoInput}
        selectedDeviceId={selectedVideoInputId}
        onSelectDevice={selectVideoInput}
      />
      <DeviceList
        visibility={audioOutput.length > 0}
        deviceCategoryLabel={'Speaker'}
        deviceList={audioOutput}
        selectedDeviceId={selectedAudioOutputId}
        onSelectDevice={selectAudioOutput}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          p: 2,
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button onClick={onClickConfirm} variant='outlined' sx={{mx:2}}>Confirm</Button>
        <Button onClick={onCancel} variant='outlined' color="warning" sx={{mx:2}}>Cancel</Button>
      </Box>
    </Box>
  );
};

export default SelectMediaDeviceComponent;